
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#001C45","fill-rule":"evenodd","d":"M12.444 14c.86 0 1.556-.696 1.556-1.556v-1.777c0-.86-.696-1.556-1.556-1.556H9.478l-1.905 2.142a9.188 9.188 0 01-2.826-2.826l2.142-1.905V3.556C6.889 2.696 6.192 2 5.333 2H3.556C2.696 2 2 2.696 2 3.556 2.006 9.32 6.679 13.994 12.444 14zm-2.366-3.556h2.366c.123 0 .223.1.223.223v1.777c0 .123-.1.223-.223.223a9.06 9.06 0 01-3.66-.767l1.294-1.456zM3.333 3.556c0-.123.1-.223.223-.223h1.777c.123 0 .223.1.223.223v2.366L4.1 7.216a9.06 9.06 0 01-.767-3.66z","clip-rule":"evenodd"}})])
          )
        }
      }
    